import { List } from 'components/order/list'
import { useEffect, useState } from 'react'
import { setModal, setOptions, setSelectedValue } from 'reducers/listReducer'
import { useDispatch, useSelector } from 'react-redux'
import {
    FILTER_REQUEST_AWB,
    TAB_REQUEST_AWB,
    TABLE_PRINT_ORDER,
    TABLE_REQUEST_AWB,
} from 'configs/order/configRequestAwb'
import { Alert } from 'avo-ui'
import Filter from 'components/commons/filter'
import { constructOptionFilter, getAllQueryParams, getObjectName, getQueryFilter, setQueryParams } from 'utils/utils'
import { useFetch } from 'services/useFetch'
import { API_REQUEST_AWB } from 'services/apiRequestAWB'
import { useLocation, useSearchParams } from 'react-router-dom'
import { RightButtonContainer } from './RightButtonContainer'

const INITIAL_FILTER = {
    start_date: null,
    end_date: null,
    shipping_aliases: [],
}

export const RequestAwbContainer = () => {
    const location = useLocation()
    const dispatch = useDispatch()
    const [searchParams, setSearchParams] = useSearchParams()
    const [isLoadingProcessAWB, setIsLoadingProcessAWB] = useState(false)
    const [typeButton, setTypeButton] = useState(null)
    const [isResetSelectedItem, setIsResetSelectedItem] = useState(false)
    const { selectedValue, modal, query: INITIAL_DATA } = useSelector((state) => state.listReducer)
    const [queryFilter, setQueryFilter] = useState({})
    const query = searchParams.size > 0 ? getAllQueryParams(searchParams) : { ...INITIAL_DATA, tab: 'request awb' }
    const { fetching: getShippingMethod } = useFetch(API_REQUEST_AWB.SHIPPING_METHODS)
    const { fetching: bulkRequestAWB, isLoading: isLoadingBulkRequestAWB } = useFetch(API_REQUEST_AWB.BULK_REQUEST_AWB)
    const { fetching: manualPrintLabel, isLoading: isLoadingManualPrintLabel } = useFetch(
        API_REQUEST_AWB.MANUAL_PRINT_LABEL,
    )
    const {
        data: requestAWBList,
        fetching: getRequestAWBList,
        isLoading: isLoadingRequestAWB,
    } = useFetch(API_REQUEST_AWB.LIST)
    const {
        data: printLabelList,
        fetching: getPrintLabelList,
        isLoading: isLoadingPrintLabel,
    } = useFetch(API_REQUEST_AWB.PRINT_LABEL_LIST)

    useEffect(() => {
        const currentQuery = { ...INITIAL_FILTER, ...query }
        const newQueryFilter = { shipping_aliases: [] }
        Object.entries(currentQuery).forEach(([key, item]) => {
            if (key === 'shipping_aliases') {
                const valueOfQuery = item?.length ? item?.split(',') : []
                newQueryFilter[key] = valueOfQuery
                currentQuery[key] = valueOfQuery
            }
        })
        fetchList(currentQuery)
        setQueryFilter(newQueryFilter)
        dispatch(setOptions({ table: currentQuery?.tab === 'request awb' ? TABLE_REQUEST_AWB : TABLE_PRINT_ORDER }))
        dispatch(setSelectedValue({ tab: currentQuery?.tab }))
    }, [location?.search])

    useEffect(() => {
        dispatch(setOptions({ tab: TAB_REQUEST_AWB }))
        if (modal?.filter) {
            getShippingMethod().then((response) => {
                FILTER_REQUEST_AWB[0].list = constructOptionFilter(response?.data, 'label')
            })
        }
    }, [modal?.filter])

    const setShowAlert = (message, itemModal, isError = false) => {
        dispatch(setModal(itemModal))
        return Alert({
            icon: isError ? 'error' : 'success',
            title: isError ? 'Error' : 'Success',
            message,
        })
    }

    const fetchList = (item = { ...INITIAL_FILTER, ...query, ...queryFilter }) => {
        query?.tab === 'request awb' ? getRequestAWBList(item) : getPrintLabelList(item)
    }

    const onChangeQuery = (queryParams) => {
        const isReset = getObjectName(queryParams)?.some((item) =>
            ['search', 'shipping_aliases', 'start_date', 'tab'].includes(item),
        )
        if (isReset) setIsResetSelectedItem(!isResetSelectedItem)
        const params = setQueryParams({ ...query, ...queryParams })
        setSearchParams(params, { replace: true })
    }

    const onChangeTab = (value) => {
        onChangeQuery({ ...INITIAL_DATA, ...INITIAL_FILTER, tab: value })
    }

    const onFilter = (filter) => {
        const queryFilter = getQueryFilter(filter)
        onChangeQuery({ ...queryFilter, page: 1 })
    }

    const rightButtonConfirm = () => {
        const payload = { order_ids: selectedValue?.selectedIds?.map((item) => item?.id) }
        if (typeButton === 'request-awb') {
            bulkRequestAWB(payload)
                .then(() => {
                    setIsResetSelectedItem(!isResetSelectedItem)
                    setIsLoadingProcessAWB(true)
                    setTimeout(() => {
                        setShowAlert('Process Request AWB Completed', { confirm: false })
                        fetchList()
                        setIsLoadingProcessAWB(false)
                    }, 2000)
                })
                .catch(() => {
                    setShowAlert('Failed Move Order to Print Label', { confirm: false }, true)
                })
        } else {
            manualPrintLabel(payload)
                .then(() => {
                    setIsResetSelectedItem(!isResetSelectedItem)
                    setShowAlert('Print Label Successfully', { confirm: false })
                    fetchList()
                })
                .catch(() => {
                    setShowAlert('Failed Move Order to Packing', { confirm: false }, true)
                })
        }
    }

    const rightButton = () => {
        return (
            <RightButtonContainer
                query={query}
                setTypeButton={setTypeButton}
                isResetSelectedItem={isResetSelectedItem}
                setIsResetSelectedItem={setIsResetSelectedItem}
                setShowAlert={setShowAlert}
                fetchList={fetchList}
            />
        )
    }

    const filter = () => {
        return (
            <Filter
                show={modal?.filter}
                setShow={(value) => dispatch(setModal({ filter: value }))}
                options={FILTER_REQUEST_AWB}
                values={queryFilter}
                onSubmit={(value) => onFilter(value)}
            />
        )
    }

    const props = {
        dataList: query?.tab === 'request awb' ? requestAWBList?.data : printLabelList?.data,
        query,
        onChangeQuery,
        onChangeTab,
        isLoading: isLoadingRequestAWB || isLoadingPrintLabel,
        isLoadingConfirm: isLoadingBulkRequestAWB || isLoadingManualPrintLabel || isLoadingProcessAWB,
        isDateRange: true,
        rightButton,
        rightButtonConfirm,
        filter,
        isResetSelectedItem,
    }

    return <List {...props} />
}
